<template>
<div class="serviceDialog" v-if="dialogVisible">
    <el-dialog title="扩充团长数量" :visible.sync="dialogVisible" @close="cancel" width="400px">
        <div class="share">
            <div class="box">
                <img :src="qrService" alt="二维码" class="img">
                <div class="pr-code-text cursor tc-red tip">扫码咨询客服</div>
            </div>
        </div>
    </el-dialog>
</div>
</template>

<script>
export default {
name: 'serviceDialog',
data() {
  return {
      dialogVisible: false,
      qrService: require('@/common/images/brandBusiness/qr_service.jpg'),
  }
},
mounted() {
},
methods: {
    openDialog() {
        this.dialogVisible = true
    },
    cancel() {
      this.dialogVisible = false
    }
},
filters: {},
watch: {},
computed: {},
components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.serviceDialog {
    .share{
        @include flexBox(space-around);
        .box{
            display: flex;
            flex-direction: column;
            justify-content: center;
            text-align: center;
            .img{
                width: 134px;
                height: 134px;
            }
            .tip{
                margin-top: 20px;
            }
        }
    }
}
</style>
